import Nav from "../components/Nav";
import ScrollProgress from "../components/ScrollProgress";
import Hero from "../components/sections/Hero";
import Services from "../components/sections/Services";
import BriefCta from "../components/sections/BriefCta";
import Work from "../components/sections/Work";
import Process from "../components/sections/Process";
import Stats from "../components/sections/Stats";
import Manifesto from "../components/sections/Manifesto";
import Faq from "../components/sections/Faq";
import Footer from "../components/sections/Footer";
import { ContactProvider } from "../components/ContactProvider";
import ExitIntent from "../components/ExitIntent";
import { Toaster } from "sonner";

export default function Landing() {
  return (
    <ContactProvider>
      <div
        data-testid="landing-page"
        className="relative bg-[#050505] text-[#F2F2F2] min-h-screen overflow-x-hidden"
      >
        <div
          aria-hidden
          className="pointer-events-none fixed inset-0 z-[1] opacity-[0.06] mix-blend-overlay grain-bg"
        />
        <Nav />
        <ScrollProgress />
        <main className="relative z-[2]">
          <Hero />
          <Services />
          <BriefCta />
          <Work />
          <Process />
          <Stats />
          <Manifesto />
          <Faq />
          <Footer />
        </main>
        <ExitIntent />
        <Toaster
          theme="dark"
          position="bottom-right"
          richColors
          toastOptions={{
            style: {
              background: "#0A0A0A",
              border: "1px solid #262626",
              color: "#F2F2F2",
              fontFamily: "Outfit, system-ui, sans-serif",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </ContactProvider>
  );
}
